import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { FooterService } from '../footer.service';
import { FooterTypeEnum } from '../../../core/enums/generated/FooterTypeEnum';

@Component({
	selector: 'pcg-view-privacy-policy-footer',
	templateUrl: './view-privacy-policy-footer.component.html',
	styleUrl: './view-privacy-policy-footer.component.scss',
	standalone: true,
	imports: [],
})
export class ViewPrivacyPolicyFooterComponent implements OnInit {
	footerService = inject(FooterService);
	title = inject(Title);

	footerDescription!: string;

	ngOnInit() {
		this.title.setTitle('Privacy Policy');
		this.footerService.getFooterItem(FooterTypeEnum.PrivacyPolicy).subscribe((vm: any) => {
			this.footerDescription = vm?.footerDescription;
		});
	}
}
